import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { TipoEvento } from '../types/TipoEvento/TipoEvento';
import { ResponseApi } from '../types/Response/ResponseApi';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APITipoEventoS = 'api/Catalog/TipoEvento/';

export default class TipoEventosService {

    static async GetTipoEventos(page: number = 1, pageSize: number = 25): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.get(
            `${SERV_BACK}${APITipoEventoS}?page=${page}&pageSize=${pageSize}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async GetTipoEventosByName(key: string, page: number = 1, pageSize: number = 25): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.get(
            `${SERV_BACK}${APITipoEventoS}byName/${key}?page=${page}&pageSize=${pageSize}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async GetTipoEventosActivos(): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.get(
            `${SERV_BACK}${APITipoEventoS}Actives`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async ActivarTipoEvento(id: number): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.put(
            `${SERV_BACK}${APITipoEventoS}Activate/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async InactivarTipoEvento(id: number): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.put(
            `${SERV_BACK}${APITipoEventoS}Inactivate/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async EditarTipoEvento(obj: TipoEvento): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.put(
            `${SERV_BACK}${APITipoEventoS}${obj.idTipoEvento}`,
            obj,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async CrearTipoEvento(obj: TipoEvento): Promise<ResponseApi<TipoEvento>> {
        const response: AxiosResponse<ResponseApi<TipoEvento>> = await apiInterceptor.post(
            `${SERV_BACK}${APITipoEventoS}`,
            obj,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

}